module.exports = __webpack_public_path__ + "09234257533a4b69595854e7c9e63821.png";